module.exports = __webpack_public_path__ + "img/icon_3_5.40181d9f.png";